import api from "../services/api";

export const login = ({ email, password }) => {
    return api.post('admin/auth/login', {
        email,
        password
    }, { skipAuth: true });
}

export const forgotPassword = ({ email }) => {
    return api.post('admin/auth/forgot_password', {
        email
    }, { skipAuth: true });
}

export const verifyOtp = ({ email, otp }) => {
    return api.post('company/auth/verify_otp', {
        email,
        otp
    }, { skipAuth: true });
}

export const resetPassword = ({ email, new_password, otp }) => {
    return api.post('company/auth/reset_password', {
        email,
        new_password,
        otp
    }, { skipAuth: true });
}

// Logout
export const logout = () => {
    return api.post('admin/auth/logout', {});
};

export const GetCompanyById = (queryParams) => {
    return api.get(`company/auth/details/get${queryParams}`);
};

// with token
export const getCurrentUser = () => {
    return api.get('admin/auth/details');
};

export const update = (formData) => {
    return api.put('admin/auth/profile',
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
}

export const changePassword = (data) => {
    return api.post('admin/auth/change_password', data);
}